/**
 * API client do Painel Comercial (Bloco D Fase 4).
 *
 *   GET /api/comercial/painel?periodo=...&vendedor=...&prioridade=...&unidade=...
 *
 * Retorna payload unico com 8 metricas + comissao_prevista_total.
 * Permissao: comercial:metricas.
 */

const PREFIXO = "/api/comercial/painel";

export function obterPainel(request, params = {}) {
  const usp = new URLSearchParams();
  if (params.periodo) usp.set("periodo", params.periodo);
  if (params.vendedor) usp.set("vendedor", params.vendedor);
  if (params.prioridade) usp.set("prioridade", params.prioridade);
  if (params.unidade) usp.set("unidade", params.unidade);
  const qs = usp.toString();
  return request(`${PREFIXO}${qs ? `?${qs}` : ""}`);
}
